define('OpenInNewTab/OpenInNewTab',[],

    function () {

        function start() {
            jQuery(document).ready(function () {
                if ($("a").hasClass("new-tab")) {
                    $("a.new-tab").attr("target", "_blank");
                }

                //On submit scroll to the top of the register form
                $(document).on('click', 'input[name="fxb.6479f578-47eb-4f40-b3ba-f8a0b0283e2e.d3acbb65-82ff-4c9c-9caf-8bab24f1781b"]', function () {
                    $("html, body").animate({ scrollTop: 0 }, "fast");
                });

                $(document).on('click', 'input[name="fxb.d1a34d69-d496-48ce-9fd5-a5096d3856ac.711e128c-c04a-4b8c-bc07-56340aa87775"]', function () {
                    $("html, body").animate({ scrollTop: 0 }, "fast");
                });

                $(document).on('click', 'input[name="fxb.5718227c-c62c-4f6f-8b14-f21269d3a279.9ea42882-ed94-4c57-b3f7-193e0b223beb"]', function () {
                    $("html, body").animate({ scrollTop: $("#fxb_5718227c-c62c-4f6f-8b14-f21269d3a279_0b6dc8e7-da57-400c-9f4e-f4f4e8bfde3f").offset().top }, "fast");
                });

                $(document).on('click', 'input[name="fxb.0c3c728e-c8a8-4bab-a26f-64c428ce7ef4.49509e40-04ce-4716-b55a-784bdce0d8e8"]', function () {
                    $("html, body").animate({ scrollTop: $("#fxb_0c3c728e-c8a8-4bab-a26f-64c428ce7ef4_b0c5e651-2bdd-4542-bab9-a47892f8b62d").offset().top }, "fast");
                });

                $(document).on('click', 'input[name="fxb.73d34eca-644b-46b1-aa77-b24528f9a65b.9ea42882-ed94-4c57-b3f7-193e0b223beb"]', function () {
                    $("html, body").animate({ scrollTop: $("#fxb_73d34eca-644b-46b1-aa77-b24528f9a65b_0b6dc8e7-da57-400c-9f4e-f4f4e8bfde3f").offset().top }, "fast");
                });

                $(document).on('click', 'input[name="fxb.efb7c7f7-39ae-4b15-9394-846b51a17904.06af2a4d-8303-4bbe-a249-2a804c353d2e"]', function () {
                    $("html, body").animate({ scrollTop: $("#fxb_efb7c7f7-39ae-4b15-9394-846b51a17904_0b6dc8e7-da57-400c-9f4e-f4f4e8bfde3f").offset().top }, "fast");
                });

                //Gene Therapy

                $(document).on('click', 'input[name="fxb.89bf16fb-c123-4ee8-b620-3fafb2b8b26f.3d4cb23b-bb2c-45b3-a61e-4c2f9fd8440f"]', function () {
                    $("html, body").animate({ scrollTop: $("#fxb_89bf16fb-c123-4ee8-b620-3fafb2b8b26f_6cfc2cec-f578-44a5-b4ea-1d53072d1dfd").offset().top }, "fast");
                });

                $(document).on('click', 'input[name="fxb.e6361fee-7dd7-428a-8b63-16de8012b1bb.fe4cd6f2-0fbd-4b4d-b488-36feff02164f"]', function () {
                    $("html, body").animate({ scrollTop: $("#fxb_e6361fee-7dd7-428a-8b63-16de8012b1bb_a71af113-ee32-495c-a3d8-fa618d30592f").offset().top }, "fast");
                });

                $(document).on('click', 'input[name="fxb.89bf16fb-c123-4ee8-b620-3fafb2b8b26f.3d4cb23b-bb2c-45b3-a61e-4c2f9fd8440f"]', function () {
                    $("html, body").animate({ scrollTop: $("#fxb_89bf16fb-c123-4ee8-b620-3fafb2b8b26f_6cfc2cec-f578-44a5-b4ea-1d53072d1dfd").offset().top }, "fast");
                });

                //Change for SCD

                $(document).on('click', 'input[name="fxb.2745feaf-e7ce-4d27-958e-89ea83929a3b.1d130536-8535-4994-8041-5af9f13afa54"]', function () {
                    $("html, body").animate({ scrollTop: $("#fxb_2745feaf-e7ce-4d27-958e-89ea83929a3b_PageItemId").offset().top }, "fast");
                });

                $(document).on('click', 'input[name="fxb.3ea277f1-a68b-465b-8261-d3e6e23780f5.7f064d9a-90ac-4b9b-b92c-285708a9e541"]', function () {
                    $("html, body").animate({ scrollTop: 0 }, "fast");
                });


                //Zynteglo

                $(document).on('click', 'input[name="fxb.b5aa6e50-ada8-42e4-8a63-16b466ed52f6.45690504-715b-45be-94bf-81810ca9f20d"]', function () {
                    $("html, body").animate({ scrollTop: $("#fxb_b5aa6e50-ada8-42e4-8a63-16b466ed52f6_ab710f05-20d2-424b-9113-edeb66bfbf1c").offset().top }, "fast");
                });

            });
        }

        return {
            start: start
        }

    }

)



;
